import * as tslib_1 from "tslib";
import { all, put, call, takeEvery } from 'redux-saga/effects';
import { Url, URLS, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import { getDeviationUrl } from '../DeviationViews/_helpers';
import { publishWriterDeviation, saveWriterDeviation, saveWriterDeviationMetadata, saveWriterDeviationSuccess, saveWriterDeviationFailure, setIsWriterDeviationFeatured, setIsRedirecting, } from './actions';
import { WriterPopupType } from './types';
import { convertToServerXhrPayload } from '../DaEditorWrapper/utils';
import { request } from '../xhr';
import { normalize } from '../redux/normalizr';
import { putEntities } from '../redux/entities/actions';
import { deviationSchema } from '../redux/normalizr/schemas/deviation';
import get from 'lodash.get';
import ddt from '@wix/da-ddt';
import { editDeviationSuccess } from '../redux/deviations/actionCreators';
var logger = ddt.createLogger('writer.saga');
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                journal: 'error',
            };
        }
        logger.log('faking the response!');
        var deviationsByType = require('@wix/da-sample-data').deviationsByType;
        var deviation = deviationsByType.journal[0];
        if (options.url === '/journal/create' ||
            options.url === '/journal/content/update' ||
            options.url === '/literature/create' ||
            options.url === '/literature/content/update') {
            deviation.title = options.data.title;
            deviation.publishedTime = undefined;
            deviation.textContent = {
                excerpt: options.data.editorSnippet,
                html: {
                    type: 'draft',
                    markup: options.data.editorRaw,
                    features: options.data.editorFeatures,
                },
            };
        }
        return { deviation: deviation };
    }
}
function doCreateWriterDeviation(action) {
    var _a, type, title, editorFeatures, cover_image_deviation_id, editorContent, editorRawState;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, type = _a.type, title = _a.title, editorFeatures = _a.editorFeatures, cover_image_deviation_id = _a.coverImageDeviationId, editorContent = _a.editorContent, editorRawState = _a.editorRawState;
                logger.log('doCreateWriterDeviation', action.payload);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/create', type),
                        data: tslib_1.__assign({ title: title,
                            cover_image_deviation_id: cover_image_deviation_id }, convertToServerXhrPayload(editorRawState, editorContent, editorFeatures)),
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}
function getWriterEndpoint(path, type) {
    if (type === void 0) { type = WriterPopupType.JOURNAL; }
    switch (type) {
        case WriterPopupType.LITERATURE:
            return "/literature" + path;
        default:
            return "/journal" + path;
    }
}
function doUpdateWriterDeviation(action) {
    var _a, type, title, deviationid, cover_image_deviation_id, editorFeatures, editorContent, editorRawState;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, type = _a.type, title = _a.title, deviationid = _a.deviationId, cover_image_deviation_id = _a.coverImageDeviationId, editorFeatures = _a.editorFeatures, editorContent = _a.editorContent, editorRawState = _a.editorRawState;
                logger.log('doUpdateWriterDeviation', action.payload);
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/update/content', type),
                        data: tslib_1.__assign({ title: title,
                            deviationid: deviationid,
                            cover_image_deviation_id: cover_image_deviation_id }, convertToServerXhrPayload(editorRawState, editorContent, editorFeatures)),
                    }, fakeResponse)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    });
}
function doCreateOrUpdateWriterDeviation(action) {
    var deviationId;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                deviationId = action.payload.deviationId;
                return [4 /*yield*/, call(deviationId ? doUpdateWriterDeviation : doCreateWriterDeviation, action)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}
function doSaveWriterDeviation(action) {
    var result, type;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!action.payload) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, call(doCreateOrUpdateWriterDeviation, action)];
            case 1:
                result = _a.sent();
                if (!(result && result.deviation)) return [3 /*break*/, 3];
                type = action.payload.type;
                return [4 /*yield*/, call(handleSuccess, { deviation: result.deviation, type: type }, action.payload.deviationId !== undefined)];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, call(handleFailure, result.error_description)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/, result];
        }
    });
}
function handleSuccess(_a, wasEdit) {
    var _b, deviationId, entities, resultActions;
    var deviation = _a.deviation, type = _a.type;
    if (wasEdit === void 0) { wasEdit = false; }
    return tslib_1.__generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = normalize(deviation, deviationSchema), deviationId = _b.result, entities = _b.entities;
                resultActions = [
                    put(putEntities({ entities: entities })),
                    put(saveWriterDeviationSuccess({ deviationId: deviationId, type: type })),
                ];
                if (wasEdit) {
                    resultActions.push(put(editDeviationSuccess({ deviation: deviation })));
                }
                return [4 /*yield*/, all(resultActions)];
            case 1:
                _c.sent();
                logger.log('success', deviationId);
                return [2 /*return*/];
        }
    });
}
function handleFailure(error) {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(saveWriterDeviationFailure({ error: error }))];
            case 1:
                _a.sent();
                logger.log('failure', error);
                return [2 /*return*/];
        }
    });
}
function handleRedirect(url) {
    return tslib_1.__generator(this, function (_a) {
        logger.log('redirect', url);
        window.location.assign(url);
        return [2 /*return*/];
    });
}
function saveWriterDeviationSaga(action) {
    var result, type;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // need to call "setIsRedirecting" before "doSaveWriterDeviation" to have a smooth
            // transition from isSubmitting to isRedirecting
            return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: true }))];
            case 1:
                // need to call "setIsRedirecting" before "doSaveWriterDeviation" to have a smooth
                // transition from isSubmitting to isRedirecting
                _a.sent();
                return [4 /*yield*/, call(doSaveWriterDeviation, action)];
            case 2:
                result = _a.sent();
                if (!(result && result.deviation)) return [3 /*break*/, 6];
                type = action.payload.type;
                if (!(type === WriterPopupType.LITERATURE)) return [3 /*break*/, 4];
                // Saving a Literature draft should redirect to the sta.sh draft folder
                // but since we do not know the drafts folder hash (yet to be implemented
                // on the backend) we should redirect to the sta.sh root
                return [4 /*yield*/, call(handleRedirect, "" + URLS.STASH)];
            case 3:
                // Saving a Literature draft should redirect to the sta.sh draft folder
                // but since we do not know the drafts folder hash (yet to be implemented
                // on the backend) we should redirect to the sta.sh root
                _a.sent();
                return [2 /*return*/];
            case 4: 
            // Upon successful submission, we should redirect to Posts/Drafts tab
            return [4 /*yield*/, call(handleRedirect, Url.userPostsLink({
                    username: (result.deviation.author && result.deviation.author.username) || '',
                    subPath: USER_PROFILE_POSTS_SUB_PATHS.DRAFTS,
                }))];
            case 5:
                // Upon successful submission, we should redirect to Posts/Drafts tab
                _a.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: false }))];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8: return [2 /*return*/];
        }
    });
}
function saveWriterDeviationMetadataSaga(action) {
    var _a, type, featured, deviationid, saveResult, result;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, type = _a.type, featured = _a.featured, deviationid = _a.deviationId;
                if (!!deviationid) return [3 /*break*/, 2];
                return [4 /*yield*/, call(doSaveWriterDeviation, action)];
            case 1:
                saveResult = _b.sent();
                deviationid = get(saveResult.deviation, 'deviationId', null);
                _b.label = 2;
            case 2: 
            // optimistic update for better UX
            return [4 /*yield*/, put(setIsWriterDeviationFeatured({ isFeatured: featured }))];
            case 3:
                // optimistic update for better UX
                _b.sent();
                return [4 /*yield*/, call(request, {
                        method: 'post',
                        url: getWriterEndpoint('/update/metadata', type),
                        data: { deviationid: deviationid, featured: featured },
                    }, fakeResponse)];
            case 4:
                result = _b.sent();
                if (!(result && result.deviation)) return [3 /*break*/, 6];
                return [4 /*yield*/, call(handleSuccess, { deviation: result.deviation, type: type })];
            case 5:
                _b.sent();
                return [3 /*break*/, 9];
            case 6: 
            // put value back if submit fails
            return [4 /*yield*/, put(setIsWriterDeviationFeatured({ isFeatured: !featured }))];
            case 7:
                // put value back if submit fails
                _b.sent();
                return [4 /*yield*/, call(handleFailure, result.error_description)];
            case 8:
                _b.sent();
                _b.label = 9;
            case 9: return [2 /*return*/];
        }
    });
}
function publishWriterDeviationSaga(action) {
    var _a, featured, type, groupId, saveResult, deviationid, result, deviation;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, featured = _a.featured, type = _a.type, groupId = _a.groupId;
                logger.log('publishWriterDeviation', action.payload);
                // need to call "setIsRedirecting" before "doSaveWriterDeviation" to have a smooth
                // transition from isSubmitting to isRedirecting
                return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: true }))];
            case 1:
                // need to call "setIsRedirecting" before "doSaveWriterDeviation" to have a smooth
                // transition from isSubmitting to isRedirecting
                _b.sent();
                return [4 /*yield*/, call(doSaveWriterDeviation, action)];
            case 2:
                saveResult = _b.sent();
                if (!(!saveResult || !saveResult.deviation)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(handleFailure, 'Could not save deviation')];
            case 3:
                _b.sent();
                return [2 /*return*/];
            case 4:
                deviationid = get(saveResult.deviation, 'deviationId', null);
                if (!(type === WriterPopupType.LITERATURE)) return [3 /*break*/, 6];
                // Literature submission should finalize on the legacy submit page
                return [4 /*yield*/, call(handleRedirect, URLS.SUBMIT + "?deviationids=" + deviationid)];
            case 5:
                // Literature submission should finalize on the legacy submit page
                _b.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, call(request, {
                    method: 'post',
                    url: getWriterEndpoint('/publish', type),
                    data: { deviationid: deviationid, featured: featured, group_id: groupId },
                }, fakeResponse)];
            case 7:
                result = _b.sent();
                logger.log('response', result);
                if (!(result && result.deviation)) return [3 /*break*/, 10];
                deviation = result.deviation;
                return [4 /*yield*/, call(handleSuccess, { deviation: deviation, type: type })];
            case 8:
                _b.sent();
                // Upon successful submission, we should redirect
                return [4 /*yield*/, call(handleRedirect, getDeviationUrl(deviation))];
            case 9:
                // Upon successful submission, we should redirect
                _b.sent();
                return [3 /*break*/, 13];
            case 10: return [4 /*yield*/, put(setIsRedirecting({ isRedirecting: false }))];
            case 11:
                _b.sent();
                return [4 /*yield*/, call(handleFailure, result.error_description)];
            case 12:
                _b.sent();
                _b.label = 13;
            case 13: return [2 /*return*/];
        }
    });
}
export default function saga() {
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(saveWriterDeviation, saveWriterDeviationSaga),
                    takeEvery(publishWriterDeviation, publishWriterDeviationSaga),
                    takeEvery(saveWriterDeviationMetadata, saveWriterDeviationMetadataSaga),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map